import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CompanyContextProvider } from './context/CompanyContext';
import { NotificationProvider } from './context/NotificationContext';  // ← ADD THIS

import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import './pages/Dashboard/Dashboard.css';
import './pages/AdminDashboard/AdminDashboard.css';
import './components/CompanyCard/CompanyCard.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import reportWebVitals from "./reportWebVitals";
import AppRoutes from "./routes/AppRoutes";

// Re-exports
export { ROLES, ROLE_LABELS, ROLE_HIERARCHY } from './constants/roles';
export { SIDEBAR_MENU } from './constants/sidebarMenu';
export { AuthProvider, useAuth } from './context/AuthContext';
export { default as MasterLayout } from './masterLayout/MasterLayout';
export { default as ProtectedRoute } from './components/ProtectedRoute';
export { default as RoleSwitcher } from './components/RoleSwitcher';
export { default as Unauthorized } from './pages/Unauthorized';
export { default as AppRoutes } from './routes/AppRoutes';
export * from './utils/Permissions';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <CompanyContextProvider>
        <NotificationProvider>        
          <AppRoutes />
        </NotificationProvider>
      </CompanyContextProvider>
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();